// Dependencies
require("section/jumbotron");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/jumbotron/index.js
 ** module id = 120
 ** module chunks = 0 1
 **/